import { ActionTree } from "vuex";
import { StateInterface } from "./types";
import { getProfile } from "shared/api";
import Vue from "vue";

const actions: ActionTree<StateInterface, {}> = {
  async setLoggedIn({ state }, loggedIn: boolean): Promise<void> {
    state.loggedIn = loggedIn;
    await Vue.nextTick();
    localStorage.setItem("loggedIn", String(loggedIn));
  },
  keepLoggedInSynced({ commit, getters, state }): void {
    const parseEvent = (e: StorageEvent): void => {
      if (
        e.key !== "loggedIn" ||
        getters.loggedInString === e.newValue ||
        (getters.loggedIn && e.newValue === null)
      )
        return;

      state.loggedIn = e.newValue === "true";

      if (!state.loggedIn) {
        commit("clearProfile");
        commit("loadInitialState", null, { root: true });
      }

      location.reload();
    };

    window.addEventListener("storage", parseEvent, {});
  },
  async ensureCurrentProfile({ state, commit }): Promise<void> {
    if (state.profile.id > 0) return;

    try {
      const profile = await getProfile();
      commit("setProfile", profile);
    } catch (e) {
      throw e;
    }
  }
};

export default actions;
